import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import api from "../../../services/api";

import { FaLock } from "react-icons/fa";
import { toast } from "react-toastify";
import { AvField, AvForm, AvGroup } from "availity-reactstrap-validation";

import {
  Container,
  Content,
  Button,
  ConfirmIco,
  Title,
  Information,
} from "./styles";

const ResetPassword = (props) => {
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const formRef = useRef(null);
  const passRef = useRef(null);
  const checkPassRef = useRef(null);

  const handleSubmit = async () => {
    setLoading(true);

    try {
      setLoading(true);
      checkPassRef.current.value &&
        passRef.current.value &&
        (await api
          .post(`session/reset-password?tkn=${props.match.params.tkn}`, {
            nova_senha: passRef.current.value,
            conf_nova_senha: checkPassRef.current.value,
          })
          .then(() => {
            toast.success(`Senha alterada com sucesso!.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            history.push("/");
          }));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <div>
        <Content>
          <Information>
            <ConfirmIco>
              <FaLock size={60} color="white" />
            </ConfirmIco>

            <Title>Resetar minha senha</Title>

            <AvForm ref={formRef} onSubmit={handleSubmit}>
              <AvGroup>
                <AvField
                  name="password"
                  innerRef={passRef}
                  type="password"
                  placeholder="Senha"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Digite sua nova senha.",
                    },
                  }}
                />
                <AvField
                  name="confirmpassword"
                  innerRef={checkPassRef}
                  type="password"
                  placeholder="Confirmar senha"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "confirme sua senha",
                    },
                  }}
                />
              </AvGroup>
              <Button type="submit" onClick={handleSubmit} disabled={loading}>
                {loading ? "Aguarde..." : "Confirmar"}
              </Button>
            </AvForm>
          </Information>
        </Content>
      </div>
    </Container>
  );
};

export default ResetPassword;
